import { Takeover } from 'types/api/orders.type';

const takeovers: Takeover[] = [
  {
    key: 'TE',
    value: 'Telephone',
  },
  {
    key: 'SR',
    value: 'Showroom',
  },
  {
    key: 'CL',
    value: 'To the customer',
  },
];

export { takeovers };
